
import LoginSection from "../../components/common/Login";

const Login = () => {
    return (
        <LoginSection />
    )
}

export default Login;